import request from '@/config/axios'

export interface ActivityAwardVO {
  id?: number
  activityId?: number
  recordId?: number
  prizeId?: number
  prizeName?: string
  prizeType?: number
  valueAmount?: number
  memberId?: number
  grantStatus?: number
  grantType?: number
  grantBean?: string
  grantBizId?: number
  grantTime?: string
  failReason?: string
  createTime?: string
}

export interface ActivityAwardPageReqVO extends PageParam {
  activityId?: number
  memberId?: number
  grantStatus?: number
  prizeType?: number
}

export const getActivityAwardPage = (params: ActivityAwardPageReqVO) => {
  return request.get({ url: '/promotion/activity-award/page', params })
}

export const regrantActivityAward = (id: number) => {
  return request.post({ url: '/promotion/activity-award/regrant', params: { id } })
}
